import { render, staticRenderFns } from "./KandidatMenu.vue?vue&type=template&id=02ce4a54&"
import script from "./KandidatMenu.vue?vue&type=script&lang=js&"
export * from "./KandidatMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports